import { CommonModule } from '@angular/common';
import { Component, Input, computed, inject } from '@angular/core';
import { AuthService } from '@app/services/auth.service';

@Component({
  selector: 'app-user-icon',
  standalone: true,
  templateUrl: './user-icon.component.html',
  imports: [ CommonModule],
})
export class UserIconComponent {
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() dark = false;
  @Input() color: 'white' | 'black' | 'blue' = 'white';

  authService = inject(AuthService);

  userInitials = computed(() => {
    return this.authService.currentUser()?.initials;
  });
}
